import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useI18n } from '../lib/i18n';

const CONSENT_KEY = 'ibrc_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { lang } = useI18n();
  const pt = lang === 'pt';

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      // Small delay so it doesn't flash on first paint
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: '110%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '110%', opacity: 0 }}
          transition={{ type: 'spring', stiffness: 260, damping: 28 }}
          role="dialog"
          aria-label={pt ? 'Aviso de cookies' : 'Cookie notice'}
          aria-live="polite"
          className="fixed bottom-0 left-0 right-0 z-[100] backdrop-blur-md bg-black/90 border-t border-white/10"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
            {/* Text */}
            <p className="font-manrope text-white/80 text-xs sm:text-sm flex-1 leading-relaxed">
              {pt
                ? 'Usamos cookies para melhorar sua experiência e analisar o tráfego do site. '
                : 'We use cookies to improve your experience and analyze site traffic. '}
              <a
                href="#acessibilidade"
                onClick={() => window.dispatchEvent(new CustomEvent('open-modal', { detail: 'acessibilidade' }))}
                className="text-[#FFC107] underline underline-offset-2 hover:text-[#FFD54F] transition-colors whitespace-nowrap"
              >
                {pt ? 'Política de Privacidade' : 'Privacy Policy'}
              </a>
            </p>

            {/* Actions */}
            <div className="flex items-center gap-2 shrink-0">
              <button
                onClick={handleReject}
                className="h-8 px-4 border border-white/30 text-white/70 font-oswald uppercase text-xs tracking-wider hover:border-white/60 hover:text-white transition-all"
                aria-label={pt ? 'Recusar cookies' : 'Reject cookies'}
              >
                {pt ? 'Recusar' : 'Reject'}
              </button>
              <button
                onClick={handleAccept}
                className="h-8 px-5 bg-[#FFC107] text-black font-oswald uppercase text-xs tracking-wider hover:bg-[#FFD54F] transition-all"
                aria-label={pt ? 'Aceitar cookies' : 'Accept cookies'}
              >
                {pt ? 'Aceitar' : 'Accept'}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
